import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';
import { messages } from '../messages';
import style from '../style.module.less';
import { usePickToToteFeatureEnabled } from '../../../../../../feature-flags/hooks/use-pick-to-tote-feature-enabled';

export const AllocationsHeader = () => {
  const isToteFeatureEnabled = usePickToToteFeatureEnabled();

  return (
    <div className={classnames(style['allocations-header'], { [style['allocations-with-tote']]: isToteFeatureEnabled })}>
      <div>
        <FormattedMessage {...messages.allocationsOrderNumber} />
      </div>
      <div>
        <FormattedMessage {...messages.allocationsOrderStatus} />
      </div>
      <div className={style.centered}>
        <FormattedMessage {...messages.allocationsNumberAllocated} />
      </div>
      {isToteFeatureEnabled && (
        <div>
          <FormattedMessage {...messages.allocationsTote} />
        </div>
      )}
    </div>
  );
};
